/**
 * ConnectionLossBanner — v.1-D §7.23, Decision D-022.
 *
 * Mounted by `AppLayout` ONLY when `useConvexConnectionState()` returns
 * `'reconnecting'`. The role="status" announces the network state to
 * assistive tech without stealing focus. Never mount unconditionally — the
 * conditional mount IS the contract.
 */
import type { JSX } from 'react';

export function ConnectionLossBanner(): JSX.Element {
  return (
    <div
      role="status"
      style={{
        background: 'var(--warn)',
        color: 'var(--canvas)',
        padding: '8px 16px',
        fontSize: 13,
        textAlign: 'center',
        fontFamily: 'var(--font-sans)',
      }}
    >
      Reconnecting…
    </div>
  );
}
